import React from 'react'
import Text from 'antd/es/typography/Text'
import { Select } from 'antd'
import useQueryParam from '../../../../../hooks/useQueryParam'
import { SORT_PARAM } from '../../../../../constants/query-params'
import { CLUSTER_SORTING_TYPES, DEFAULT_CLUSTER_SORTING_TYPE } from '../../../../../constants/sorting-types'
import useQueryParamSetter from '../../../../../hooks/useQueryParamSetter'
import { useSelector } from 'react-redux'

const GroupsSort = () => {
    const isWaitingForClusters = useSelector(state => state.assignment.isWaitingForClusters)

    const sortParam = useQueryParam(SORT_PARAM) || DEFAULT_CLUSTER_SORTING_TYPE
    const setQueryParam = useQueryParamSetter()

    const sortingOptions = Object.keys(CLUSTER_SORTING_TYPES).map(key => ({
        label: CLUSTER_SORTING_TYPES[key].label,
        value: CLUSTER_SORTING_TYPES[key].value,
    }))

    const handleSortChange = value => {
        setQueryParam({ [SORT_PARAM]: value })
    }

    return (
        <label className='d-flex-column'>
            <Text className='mb-4' type='secondary'>
                Sort by
            </Text>
            <Select
                value={sortParam}
                style={{ minWidth: 80 }}
                popupMatchSelectWidth={false}
                onChange={handleSortChange}
                disabled={isWaitingForClusters}
                options={sortingOptions}
                showSearch
                optionFilterProp='label'
            />
        </label>
    )
}

export default GroupsSort
